<main class="dashboard">
  <!-- Breadcrumbs -->
  <xng-breadcrumb>
    <div class="breadcrumbs" *xngBreadcrumbItem="let breadcrumb">
      <div class="container-xl">
        <ul class="breadcrumbs-list">
          <li><a [routerLink]="['/home']">Home</a></li>
          <li>
            <a> {{ breadcrumb }}</a>
          </li>
        </ul>
      </div>
    </div>
  </xng-breadcrumb>

  <section class="container-xl">
    <div class="controls top-line">
      <div class="description text-center">
        <i class="icon-access-denied"></i>
        <h1>Access Denied</h1>
        <h3>You don't have access to view this page.</h3>
        <p>Contact an administrator to get permissions or <a href="/home">go to home</a> page and browse other page</p>
      </div>
    </div>
  </section>
</main>
